import React, { useEffect, useState } from "react";
import style from "../solo.module.sass";
import CloseSvg from '../../../../../assets/svg/deleteX.svg';
import emptyVariableAclIcon from "../../../../../assets/svg/solo/variableAclNotConfigured.svg"
import Service from './Service';
import Form from './Form'
import Condition from "./Condition";
import AssistJourney from "./AssistedJourney"
import WebHook from "./WebHook";
import Timer from "./Timer";
import Event from "./Event"
import Message from "./message"
import LiveAgent from "./LiveAgent"
import Subflow from "./Subflow"
import Classifier from "./classifier";
import AiAgent from "./ai-agents";
import Action from "./Action";

const Properties = (props: any) => {/* eslint-disable */
    const { data, setWidgetDrawer, widgetDrawer, nodesContext } = props
    // const [widgetDrawer, setWidgetDrawer]: any = useState(false);
    const [toggleEnable, setToggleEnable]: any = useState(false)
    const [showVariableAcl, setShowVariableAcl] =useState(false)
    const [aclIcon, setAclIcon] = useState(emptyVariableAclIcon)

    useEffect(() => {
        if (!data || data.nodeDetail.type === "stop" || data.nodeDetail.type === "start" || data.nodeDetail.type === "return") {
            setWidgetDrawer(false);
        }
        // else {
        //     setWidgetDrawer(true)
        // }
    }, [data])

    return (
        <div className={style.properties} style={{ left: props.widgetDrawer ? 0 : -400 }}>
            {<div style={{ display: "flex", flexDirection: "row" }}>
                <div className={style.header} style={{ boxShadow: "0px 3px 7px #B0BACE24" }}>
                    <label style={{ color: "#0F66C8" }}>
                        {!showVariableAcl && data && data.nodeDetail ? data.nodeDetail.data.label: showVariableAcl ? "Variable ACL" : "Properties"}
                    </label>
                    <div style={{ display: "flex", flexDirection: "row",  justifyContent: "flex-end" }}>
                        {/* {!toggleEnable && !props.lock && props.data.nodeDetail.type === "condition" &&
                            <img alt="togleDisable" src={togleDisabledSvg}
                                onClick={() => { setToggleEnable(true) }} />}
                        {toggleEnable && !props.lock && props.data.nodeDetail.type === "condition" &&
                            <img alt="togleEnable" src={togleEnabled}
                                onClick={() => { setToggleEnable(false) }} />} */}
                            {(!showVariableAcl && data && data.nodeDetail.type != "condition" && data.nodeDetail.type != "event" && data.nodeDetail.type !== "message" && data.nodeDetail.type !== "subflow") &&
                                <img style={{ marginRight: 4 }} alt="variableAcl" title="Configure Variable ACL" src={aclIcon} onClick={() => { setShowVariableAcl(true) }} />}
                            <img alt="close" src={CloseSvg} onClick={() => { setWidgetDrawer(false); setShowVariableAcl(false) }} />
                    </div>
                </div>
                <div className={style.fields}>
                </div>
            </div>}
            {(data && data.nodeDetail.type === "service") &&
                <Service
                    nameCheck={props.nameCheck}
                    lock={props.lock}
                    form={props.forms}
                    elements={props.elements}
                    widgetDrawer={widgetDrawer}
                    soloServices={props.soloServices}
                    soloBuildinServices={props.soloBuildinServices}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    setWidgetDrawer={props.setWidgetDrawer}
                    showVariableAcl={showVariableAcl}
                    setShowVariableAcl={setShowVariableAcl}
                    setAclIcon={setAclIcon}
                    nodesContext={nodesContext}
                    nodeDetail={props.data.nodeDetail}>
                </Service>}
            {(data && data.nodeDetail.type === "form") &&
                <Form
                    widgetDrawer={widgetDrawer}
                    form={props.forms}
                    lock={props.lock}
                    nameCheck={props.nameCheck}
                    elements={props.elements}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    showVariableAcl={showVariableAcl}
                    setShowVariableAcl={setShowVariableAcl}
                    setAclIcon={setAclIcon}
                    nodeDetail={props.data.nodeDetail}
                    >
                </Form>}
            {(data && data.nodeDetail.type === "condition") &&
                <Condition
                    widgetDrawer={widgetDrawer}
                    nameCheck={props.nameCheck}
                    lock={props.lock}
                    toggle={toggleEnable}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    elements={props.elements}
                    nodeDetail={props.data.nodeDetail}>
                </Condition>}
            {(data && data.nodeDetail.type === "assistedJourney") &&
                <AssistJourney
                    widgetDrawer={widgetDrawer}
                    nameCheck={props.nameCheck}
                    lock={props.lock}
                    toggle={toggleEnable}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    elements={props.elements}
                    soloServices={props.soloServices}
                    forms={props.forms}
                    showVariableAcl={showVariableAcl}
                    setShowVariableAcl={setShowVariableAcl}
                    setAclIcon={setAclIcon}
                    nodeDetail={props.data.nodeDetail}>
                </AssistJourney>
            }
            {(data && data.nodeDetail.type === "webhook") &&
                <WebHook
                    widgetDrawer={widgetDrawer}
                    forms={props.forms}
                    soloServices={props.soloServices}
                    nameCheck={props.nameCheck}
                    lock={props.lock}
                    toggle={toggleEnable}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    elements={props.elements}
                    showVariableAcl={showVariableAcl}
                    setShowVariableAcl={setShowVariableAcl}
                    setAclIcon={setAclIcon}
                    nodeDetail={props.data.nodeDetail}>
                </WebHook>
            }
             {(data && data.nodeDetail.type === "timer") &&
                <Timer
                    widgetDrawer={widgetDrawer}
                    form={props.forms}
                    lock={props.lock}
                    nameCheck={props.nameCheck}
                    elements={props.elements}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    showVariableAcl={showVariableAcl}
                    setShowVariableAcl={setShowVariableAcl}
                    setAclIcon={setAclIcon}
                    nodeDetail={props.data.nodeDetail}>
                </Timer>}
            {(data && data.nodeDetail.type === "event") &&
                <Event
                    widgetDrawer={widgetDrawer}
                    nameCheck={props.nameCheck}
                    lock={props.lock}
                    toggle={toggleEnable}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    elements={props.elements}
                    getFlowDetails={props.getFlowDetails}
                    flowDetail={props.flowDetail}
                    nodeDetail={props.data.nodeDetail}>
                </Event>}
            {(data && data.nodeDetail.type === "message") &&
                <Message
                    widgetDrawer={widgetDrawer}
                    nameCheck={props.nameCheck}
                    lock={props.lock}
                    toggle={toggleEnable}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    elements={props.elements}
                    getFlowDetails={props.getFlowDetails}
                    flowDetail={props.flowDetail}
                    nodeDetail={props.data.nodeDetail}>
                </Message>}
            {(data && data.nodeDetail.type === "liveAgent") &&
            <LiveAgent 
              widgetDrawer={widgetDrawer} 
              nodeDetail={props.data.nodeDetail} 
              lock={props.lock} 
              nameCheck={props.nameCheck}  
              elements={props.elements}
              setWidgetDrawer={props.setWidgetDrawer}
              onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
              showVariableAcl={showVariableAcl}
              setShowVariableAcl={setShowVariableAcl}
              setAclIcon={setAclIcon}
          />}
            {(data && data.nodeDetail.type === "subflow") &&
                <Subflow
                    widgetDrawer={widgetDrawer}
                    nameCheck={props.nameCheck}
                    lock={props.lock}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    nodeDetail={props.data.nodeDetail}
                    flowDetail={props.flowDetail}
                    elements={props.elements}
                    nodesContext={nodesContext}
                    flows={props.flows}>
                </Subflow>}
            {(data && data.nodeDetail.type === "aiClassifier") &&
                <Classifier
                    widgetDrawer={widgetDrawer}
                    nameCheck={props.nameCheck}
                    lock={props.lock}
                    form={props.forms}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    nodeDetail={props.data.nodeDetail}
                    flowDetail={props.flowDetail}
                    elements={props.elements}
                    nodesContext={nodesContext}
                    flows={props.flows}
                />}
            {(data && data.nodeDetail.type === "aiAgent") &&
                <AiAgent
                    widgetDrawer={widgetDrawer}
                    nameCheck={props.nameCheck}
                    lock={props.lock}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    nodeDetail={props.data.nodeDetail}
                    flowDetail={props.flowDetail}
                    elements={props.elements}
                    nodesContext={nodesContext}
                    flows={props.flows}
                    form={props.forms}
                    showVariableAcl={showVariableAcl}
                    setShowVariableAcl={setShowVariableAcl}
                    setAclIcon={setAclIcon}
                />}
            {(data && data.nodeDetail.type === "action" && widgetDrawer) &&
                <Action
                    widgetDrawer={widgetDrawer}
                    nameCheck={props.nameCheck}
                    lock={props.lock}
                    setWidgetDrawer={props.setWidgetDrawer}
                    onUpdateProperties={(propertyInfo: any) => props.onUpdateProperties(propertyInfo)}
                    nodeDetail={props.data.nodeDetail}
                    form={props.forms}
                    showVariableAcl={showVariableAcl}
                    setShowVariableAcl={setShowVariableAcl}
                    elements={props.elements}
                />}
        </div>
    );
}

export default Properties;
